module.exports = __webpack_public_path__ + "static/media/MaisonNeue-Medium.a8d4d0a0.woff";